import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DropdownItem from './UserDropdownItem';
import { DropdownMenu } from './styled';
import AppearanceMenu from './components/AppearenceMenu';
import AppearanceDropdown from './components/AppearenceItem';
import { Hr } from './components/AppearenceMenu/styled';

const UserDropdown = ({ modals }) => {
  const {
    Help, Extras, About, Preferences
  } = modals;
  const [appearance, setAppearance] = useState(false);

  if (appearance) return <AppearanceMenu setAppearance={ setAppearance } />;
  return (
    <DropdownMenu>
      <DropdownItem Modal={ Preferences }>Preferences</DropdownItem>
      <Hr />
      <DropdownItem link="/api-definitions" >Faraday Api</DropdownItem>
      <AppearanceDropdown setAppearance={ setAppearance } />
      <DropdownItem Modal={ Help }>Help</DropdownItem>
      <DropdownItem Modal={ Extras }>Extras</DropdownItem>
      <DropdownItem Modal={ About }>About</DropdownItem>
      <DropdownItem link="/logout">Logout</DropdownItem>
    </DropdownMenu>
  );
};

UserDropdown.propTypes = {
  modals: PropTypes.shape({
    Extras: PropTypes.object.isRequired,
    Help: PropTypes.object.isRequired,
    About: PropTypes.object.isRequired,
    Preferences: PropTypes.object.isRequired
  }).isRequired
};

export default UserDropdown;
